import c1 from './ss/ss_1.webp';
import c2 from './ss/ss_2.webp';
import c3 from './ss/ss_3.webp';
import c4 from './ss/ss_4.webp';
import c5 from './ss/ss_5.webp';
import c6 from './ss/ss_6.webp';
import c7 from './ss/ss_7.webp';
import c8 from './ss/ss_8.webp';
import c9 from './ss/ss_9.webp';
import c10 from './ss/ss_10.webp';
import c11 from './ss/ss_11.webp';
import c12 from './ss/ss_12.webp';
import c13 from './ss/ss_13.webp';
import c14 from './ss/ss_14.webp';
import c15 from './ss/ss_15.webp';
import c16 from './ss/ss_16.webp';
import c17 from './ss/ss_17.webp';
import c18 from './ss/ss_18.webp';
import c19 from './ss/ss_19.webp';
import c20 from './ss/ss_20.webp';
import c21 from './ss/ss_21.webp';
import c22 from './ss/ss_22.webp';
import c23 from './ss/ss_23.webp';
import c24 from './ss/ss_24.webp';
import c25 from './ss/ss_25.webp';
import c26 from './ss/ss_26.webp';
import c27 from './ss/ss_27.webp';
import c28 from './ss/ss_28.webp';
import c29 from './ss/ss_29.webp';
import c30 from './ss/ss_30.webp';
import c31 from './ss/ss_31.webp';
import c32 from './ss/ss_32.webp';
import c33 from './ss/ss_33.webp';
import c34 from './ss/ss_34.webp';
import c35 from './ss/ss_35.webp';
import c36 from './ss/ss_36.webp';
import c37 from './ss/ss_37.webp';
import c38 from './ss/ss_38.webp';
import c39 from './ss/ss_39.webp';
import c40 from './ss/ss_40.webp';
import c41 from './ss/ss_41.webp';
import c42 from './ss/ss_42.webp';
import c43 from './ss/ss_43.webp';
import c44 from './ss/ss_44.webp';
import c45 from './ss/ss_45.webp';
import c46 from './ss/ss_46.webp';
import c47 from './ss/ss_47.webp';
import c48 from './ss/ss_48.webp';
import c49 from './ss/ss_49.webp';
import c50 from './ss/ss_50.webp';
import c51 from './ss/ss_51.webp';
import c52 from './ss/ss_52.webp';
import c53 from './ss/ss_53.webp';
import c54 from './ss/ss_54.webp';
import c55 from './ss/ss_55.webp';
import c56 from './ss/ss_56.webp';
import c57 from './ss/ss_57.webp';
import c58 from './ss/ss_58.webp';
import c59 from './ss/ss_59.webp';
import c60 from './ss/ss_60.webp';
import c61 from './ss/ss_61.webp';
import c62 from './ss/ss_62.webp';
import c63 from './ss/ss_63.webp';
import c64 from './ss/ss_64.webp';
import c65 from './ss/ss_65.webp';
import c66 from './ss/ss_66.webp';
import c67 from './ss/ss_67.webp';
import c68 from './ss/ss_68.webp';
import c69 from './ss/ss_69.webp';
import c70 from './ss/ss_70.webp';

const ssImg = [
	c1,
	c2,
	c3,
	c4,
	c5,
	c6,
	c7,
	c8,
	c9,
	c10,
	c11,
	c12,
	c13,
	c14,
	c15,
	c16,
	c17,
	c18,
	c19,
	c20,
	c21,
	c22,
	c23,
	c24,
	c25,
	c26,
	c27,
	c28,
	c29,
	c30,
	c31,
	c32,
	c33,
	c34,
	c35,
	c36,
	c37,
	c38,
	c39,
	c40,
	c41,
	c42,
	c43,
	c44,
	c45,
	c46,
	c47,
	c48,
	c49,
	c50,
	c51,
	c52,
	c53,
	c54,
	c55,
	c56,
	c57,
	c58,
	c59,
	c60,
	c61,
	c62,
	c63,
	c64,
	c65,
	c66,
	c67,
	c68,
	c69,
	c70,
];

export default ssImg;
